import { Grid } from "@mui/material";
import ExplorerGrid, { useExplorerGrid } from "common/ExplorerGrid";
import { Can } from "context/permissionContenxt";
import PageNotFound from "pages/PageNotFound";
import Cube from "qubCommon/CubeStats/Cube";
import useToolbarProps from "qubCommon/ExplorerToolbar/useToolbarProps";
import { Dropdown, TextInput } from "qubCommon/Inputs";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const WhitelistExplorer = () => {
  const [showStatistics, setShowStatistics] = useState(false);
  const [statisticsData, setStatisticsData] = useState([]);
  const [statisticsColumns, setStatisticsColumns] = useState([]);
  const [contextMenuIds, setContextMenuIds] = useState({});

  const navigate = useNavigate();

  const { status, critParams, ...toolbarRest } = useToolbarProps({
    webPageKey: "Whitelist-Expl",
    hideAddNew: true,
  });

  const { explParams, ...explorerRest } = useExplorerGrid({
    explorerDataKey: "Whitelist-Expl",
    xlsxName: "Whitelist",
    status,
  });

  const handleShowStatistics = async () => {
    const helpCols = [];
    const { initColumns } = toolbarRest;
    if (initColumns?.length > 0)
      initColumns.forEach((column) =>
        column.children.forEach((child) =>
          helpCols.push({
            binding: child?.fldName,
            header: child?.fldTitle,
            visible: child?.isVisible,
            format: child?.fldFormat,
            position: child?.fldPosition,
            width: child?.colWidth ?? "*",
            align: child?.colAlign ?? "center",
            multiline: child?.multiline,
          })
        )
      );
    setShowStatistics(true);
    setStatisticsData(explorerRest?.gridData?.items);
    setStatisticsColumns(helpCols);
  };

  const handleHideStatistics = async () => {
    setShowStatistics(false);
    setStatisticsData([]);
    setStatisticsColumns([]);
  };

  // Usage

  return (
    <>
      <Can I="View" a="Whitelist">
        <div
          style={{
            margin: 20,
            padding: 20,
            borderRadius: 8,
            backgroundColor: "#f3f3f3",
          }}
        >
          {showStatistics ? (
            <Cube
              data={statisticsData}
              columns={statisticsColumns}
              onClose={() => setShowStatistics(false)}
              hideStatistics={handleHideStatistics}
            />
          ) : (
            <ExplorerGrid
              explParams={explParams}
              title="Whitelist"
              breadcrumbs={[{ name: "Whitelist", path: "govnr/Whitelist" }]}
              hideAscendingRowNumber
              autoRowHeights
              // buttons={
              //   <Box boxShadow={2} sx={{ borderRadius: 50 }}>
              //     <Tooltip title="Στατιστικα" onClick={handleShowStatistics}>
              //       <IconButton>
              //         <BarChart />
              //       </IconButton>
              //     </Tooltip>
              //   </Box>
              // }
              contextMenuIds={contextMenuIds}
              {...explorerRest}
              {...toolbarRest}
              // cleanFilters={<Button
              //   variant='contained'
              //   color='error'
              //   sx={{ marginLeft: 1 }}
              //   onClick={removeLocalStorageItems}
              // >
              //   Επαναφορά Φίλτρων
              // </Button>}
            >
              <Grid item xs={12} md={6} lg={3}>
                <TextInput
                  id="Search"
                  name="searchFieldValue"
                  label={"Αναζήτηση"}
                  placeholder={"Αναζήτηση"}
                />
              </Grid>
              {toolbarRest?.lookups?.map((lk) => {
                return (
                  <Grid key={lk.value} item xs={12} md={6} lg={3}>
                    <Dropdown
                      id={lk.value}
                      name={lk.value}
                      label={lk.title}
                      options={lk?.children}
                      labelName="title"
                      valueName="value"
                    />
                  </Grid>
                );
              })}
            </ExplorerGrid>
          )}
        </div>
      </Can>
      <Can not I="View" a="Whitelist">
        <PageNotFound />
      </Can>
    </>
  );
};
export default WhitelistExplorer;
